/**
 * Really basic cookie manager
 * @param {*} name - just the cookie name
 * @returns 
 */
class Cookies {
	
	static get(name) {
	  let value = `; ${document.cookie}`;
	  let parts = value.split(`; ${name}=`);
	  if (parts.length === 2) return parts.pop().split(';').shift();
	}
  
	static set(name, days=7) {
	  var maxAge = 60 * 60 * 24 * days;
	  document.cookie = `${name}=${ new Date().getTime() }; max-age=${ maxAge }; path=/`;
	}

	static clear(name) {
		document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
	}

}
  
export default Cookies;